import React from 'react';
import { Modal, message } from 'antd';
import { setLandingPage } from '@api/landingPage';
import {
  TAB_TITLE_TRENDS,
} from '@utils/constants';

const RemoveDashboardPopup = ({
  visible,
  toggleVisible,
  isFetching,
  hasError,
  id,
  init,
  removeDashboard,
  updateDefaultLandingPage,
  defaultLandingPage,
}) => {
  React.useEffect(() => {
    if (!visible) {
      init();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);
  const { pathname } = window.location;
  const defaultPathname = defaultLandingPage.url || '';
  const isDefaultLandingPage = defaultPathname.endsWith(pathname);
  const handleOk = React.useCallback(
    () => {
      if (id > 0) {
        if (isDefaultLandingPage) {
          const payload = {
            url: '',
            path: '',
            name: '',
          };
          setLandingPage(payload).then(() => {
            updateDefaultLandingPage(payload);
            removeDashboard(id, isDefaultLandingPage);
          });
        } else {
          removeDashboard(id, isDefaultLandingPage);
        }
      } else {
        message.error('Can\'t find the dashboard.');
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [id, defaultLandingPage],
  );

  const strArr = ['Are you sure you want to delete the dashboard?'];
  if (isDefaultLandingPage) {
    strArr.push(`If deleted then your default dashboard will reset to system default dashboard ${TAB_TITLE_TRENDS}.`);
  }
  const contentArr = strArr.map(e => <div key={e}>{e}</div>);

  return (
    (<Modal
      title="Delete dashboard"
      open={visible}
      onOk={handleOk}
      confirmLoading={!hasError && isFetching}
      onCancel={toggleVisible}
      maskClosable={false}
    >
      {contentArr}
    </Modal>)
  );
};

export default RemoveDashboardPopup;
